import React from 'react';
import debounce from 'debounce';
import { Select } from 'antd';

import {
  _getSearchExStock
} from '../../services'

const { Option } = Select

/* Allows searching by title, sku, model */
class ProductSearch extends React.Component {

  constructor(props){
    super(props)
    this.state = {
      data: []
    }

    this.handleSearch = debounce(this.handleSearch, 1000)
  }

  render() {
    const options = this.state.data.map(d => <Option key={d._id}>{d.title}</Option>);
    return (
      <Select
        showSearch
        value={this.state.value}
        style={{width: '300px'}}
        placeholder={'Search for a product here'}
        defaultActiveFirstOption={false}
        showArrow={false}
        filterOption={false}
        onSearch={this.handleSearch}
        onChange={this.handleChange}
        notFoundContent={null}
      >
        {options}
      </Select>
    );
  }

  handleSearch = (value) => {
    if (value) {
      _getSearchExStock({
        searchParam: value, 
      })
      .then(_data => {
        console.log(_data)
        this.setState({
          data: _data.data
        })
      })
    } else {
      this.setState({ data: [] });
    }
  };

  handleChange = (value) => {
    this.setState({ value });
    this.props.onProductChange(value)
  };
}

export default ProductSearch


// WEBPACK FOOTER //
// ./src/components/product-ex-stock/product-search.js